export default class Registry<T> {
    private readonly filters: T[] = [];

    public register(filter: T): void {
        this.filters.push(filter);
    }

    public unregister(filter: T): void {
        const index = this.filters.indexOf(filter);
        if (index >= 0) {
            this.filters.splice(index, 1);
        }
    }

    public getAll<TItem extends T>(): TItem[] {
        return this.filters as TItem[];
    }
}
